const prefix = 'features/common/confirmation-dialog';

export const SHOW_CONFIRMATION_DIALOG = `${prefix}/SHOW`;
export const HIDE_CONFIRMATION_DIALOG = `${prefix}/HIDE`;
export const CONFIRM = `${prefix}/CONFIRM`;
export const CANCEL = `${prefix}/CANCEL`;



// WEBPACK FOOTER //
// ./src/store/features/common/confirmation-dialog/action-types.js